module.exports = __webpack_public_path__ + "static/media/img-tuberia-03.d8c0a299.jpg";